import React from 'react'
import PropTypes from 'prop-types'

const MyListAdded = ({ width, height, color }) => (
  <svg width={width} height={height} viewBox="0 0 18 18" fill={color} xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9" r="8" stroke="#C448F0" />
    <path d="M12.667 6.50001L7.66699 11.5L5.00033 8.99998" stroke="#C448F0" strokeLinecap="square" />
  </svg>
)

MyListAdded.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  color: PropTypes.string,
}

MyListAdded.defaultProps = {
  width: 18,
  height: 18,
  color: '',
}

export default MyListAdded
